import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../app/app.environment';

export interface PettyCash {
  id?: number;
  uuid?: string;
  expensetype_id?: number;
  paytype?: number;
  expensedate?: string;
  bankaccount_id?: number;
  amount: number;
  description: string;
  file?: string;
  status?: number;
  createdBy?: number;
  warehouse_id?: number;
  updatedBy?: number;
  createdAt?: string;
  updatedAt?: string;
  expensetype?: {
    id: number;
    name: string;
    description: string;
    status: number;
    createdBy: number;
    createdAt: string;
    updatedAt: string;
  };
  // Legacy fields for backward compatibility
  type?: 'Paid' | 'Received' | 'paid' | 'received';
  entryBy?: string;
  cashFor?: string;
  date?: string;
}

export interface PettyCashResponse {
  status: number;
  message: string;
  datas: PettyCash[];
  totalItems: number;
  totalPages: number;
  currentPage: number;
}

export interface ExpenseType {
  id: number;
  name: string;
  description: string;
  status: number;
  createdBy: number;
  createdAt: string;
  updatedAt: string;
}

export interface ExpenseTypesResponse {
  status: number;
  message: string;
  data: ExpenseType[];
}

export interface PettyCashCreateRequest {
  expensetype_id: number;
  amount: number;
  description: string;
  expenseType: 'paid' | 'received';
  cashFor: string;
  entryTimestamp: string;
  entryBy: string;
}



@Injectable({
  providedIn: 'root'
})
export class PettyCashService {
  apiUrl = environment.apiURL + 'v1/cash/pettycash';
  expenseTypesUrl = environment.apiURL + 'v1/cash/expensetypes';

  constructor(private http: HttpClient) {}

  getPettyCash(): Observable<PettyCashResponse> {
    return this.http.get<PettyCashResponse>(this.apiUrl);
  }

  getPettyCashById(id: string): Observable<PettyCash> {
    return this.http.get<PettyCash>(`${this.apiUrl}/${id}`);
  }

  createPettyCash(pettyCash: PettyCash): Observable<PettyCash> {
    return this.http.post<PettyCash>(this.apiUrl, pettyCash);
  }

  createPettyCashNew(request: PettyCashCreateRequest): Observable<any> {
    return this.http.post<any>(this.apiUrl, request);
  }

  updatePettyCash(id: string, pettyCash: PettyCash): Observable<PettyCash> {
    return this.http.put<PettyCash>(`${this.apiUrl}/${id}`, pettyCash);
  }

  deletePettyCash(id: string, pettyCash?: PettyCash): Observable<any> {
    if (pettyCash) {
      return this.http.delete<any>(`${this.apiUrl}/${id}`, { body: pettyCash });
    } else {
      return this.http.delete<any>(`${this.apiUrl}/${id}`);
    }
  }

  getOpeningBalance(): Observable<{ openingBalance: number }> {
    return this.http.get<{ openingBalance: number }>(`${this.apiUrl}/opening-balance`);
  }

  getCurrentBalance(): Observable<{ currentBalance: number }> {
    return this.http.get<{ currentBalance: number }>(`${this.apiUrl}/current-balance`);
  }

  // Deprecated - use getCurrentBalance instead
  getTotalCashIn(): Observable<{ currentBalance: number }> {
    return this.getCurrentBalance();
  }

  // Expense Types API
  getExpenseTypes(): Observable<ExpenseTypesResponse> {
    return this.http.get<ExpenseTypesResponse>(this.expenseTypesUrl);
  }
}
